// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AngleSection-module--wrapper--Yz4Xz","contentSpacer":"AngleSection-module--contentSpacer--yDT9A","content":"AngleSection-module--content--23yr-"};